import { createFileRoute } from '@tanstack/react-router'
import { ChoreManager } from '@/features/chores/ChoreManager'
import { PageHeading } from '@/components/PageHeading'

export const Route = createFileRoute('/chores')({
  component: ChoresPage,
})

function ChoresPage() {
  return (
    <div className="py-6 sm:py-8">
      <PageHeading title="Chores" />
      <div className="mt-6">
        <ChoreManager />
      </div>
    </div>
  )
}
